"use client"

import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import useCartService from '@/lib/hooks/useCartStore';
import CurrencyPrice from '@/components/CurrencyPrice';
import useShowPricing from '@/lib/hooks/useShowPricing';

const CartDetails = () => {
  const { items, itemsPrice, decrease, increase, removeItem } = useCartService();
  const { showPricing } = useShowPricing();
  const [mounted, setMounted] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setMounted(true);
  }, [items, itemsPrice, decrease, increase, removeItem]);

  if (!mounted) return <>Loading...</>;

  return (
    <div>
      <h1 className='py-4 text-2xl'>Shopping Cart</h1>
      {items.length === 0 ? (
        <div>
          <p className='mb-2'>Cart is empty :(</p>
          <Link href='/' className='btn'>
            Go shopping
          </Link>
        </div>
      ) : (
        <div className='grid md:grid-cols-4 md:gap-5'>
          <div className='overflow-x-auto md:col-span-3'>
            <table className='table'>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.slug}>
                    <td className='flex items-center'>
                      <Link href={`/product/${item.slug}`} className='flex items-center'>
                        <Image src={item.photos[0]} alt={item.name} width={50} height={50} />
                      </Link>
                      <span className='px-2'>{item.partNumber}</span>
                    </td>
                    <td>
                      <div>
                        <Button variant='outline' size='sm' onClick={() => decrease(item)}>
                          -
                        </Button>
                        <span className='px-2'>{item.qty}</span>
                        <Button variant='outline' size='sm' onClick={() => increase(item)}>
                          +
                        </Button>
                      </div>
                    </td>
                    <td> <CurrencyPrice price={item.price} usPrice={item.usPrice}/> </td>
                    <td>
                      <Button variant='destructive' size='sm' onClick={() => removeItem(item)}>
                        Remove
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='card'>
            <div className='card-body'>
              <ul>
                <li className='pb-3 text-xl'>
                  Subtotal: {items.reduce((acc, item) => acc + item.qty, 0)}:
                  <br /><CurrencyPrice justSign={true}/> {showPricing ? itemsPrice : ''}
                </li>
                <li>
                  <Button variant='primary' size='lg' className='w-full' onClick={() => router.push('/shipping')}>
                    Proceed to Checkout
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartDetails;
